// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prev[data-v-602b03e6] {\n  left: 0;\n}\n.next[data-v-602b03e6] {\n  right: 0;\n}\n@media (max-width: 450px){\n.history-calendar-box[data-v-602b03e6] {\n    flex-flow: nowrap;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
